import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkdown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMarkdown"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 9H7.95377L9.25 10.4814L10.5462 9H12.5V15H10.5V12.09L9.25 13.5186L8 12.09V15H6V9ZM17 9V11.75H18.819L16 15.1731L13.181 11.75H15V9H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkdown;
